/**
 * ht-flavor-picker.js
 * Happy Tails 味の配分ピッカー
 * - set:20  → モード（3種ミックス / 2種 / 1種）
 * - set:100 → 25個入り×4袋を配分
 * - set:200 → 25個入り×8袋を配分
 * 選択結果を明細プロパティ properties[味の内訳] に書き込み、
 * 合計が合わないうちは購入ボタンを無効化する。
 */
(function () {
  'use strict';

  var FLAVORS = ['モカ', 'スペシャル', 'イタリアン'];
  var FLAVOR_CODES = { 'モカ': 'M', 'スペシャル': 'S', 'イタリアン': 'I' };

  function initPicker(root) {
    if (root.dataset.htfpInit === '1') return;
    root.dataset.htfpInit = '1';

    var set = parseInt(root.getAttribute('data-ht-set'), 10) || 0;
    var bags = parseInt(root.getAttribute('data-ht-bags'), 10) || 0;
    var stepSize = parseInt(root.getAttribute('data-ht-step-size'), 10) || 25;
    var submitId = root.getAttribute('data-ht-submit');
    var propInput = root.querySelector('[data-htfp-prop]');
    var shippingLabelInput = root.querySelector('[data-htfp-shipping-label]');
    var statusEl = root.querySelector('[data-htfp-status]');
    var hintEl = root.querySelector('[data-htfp-hint]');

    function submitBtn() { return submitId ? document.getElementById(submitId) : null; }
    function setValid(valid) {
      var btn = submitBtn();
      if (btn) btn.disabled = !valid;
    }
    function setStatus(text, ok) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      statusEl.className = 'htfp__status ' + (ok ? 'htfp__status--ok' : 'htfp__status--ng');
    }
    function setHint(text) { if (hintEl) hintEl.textContent = text || ''; }

    if (set === 20) {
      initModeUI(root, propInput, shippingLabelInput, setValid, setStatus, setHint);
    } else {
      initStepperUI(root, bags, set, stepSize, propInput, shippingLabelInput, setValid, setStatus, setHint);
    }
  }

  /* ── 20個：モード式 ─────────────────────────── */
  function initModeUI(root, propInput, shippingLabelInput, setValid, setStatus, setHint) {
    var modeBtns = root.querySelectorAll('[data-mode]');
    var flavorArea = root.querySelector('[data-htfp-flavors]');
    var mode = 'mix';
    var selected = []; // 'two'/'one' 用の選択済み味

    function render() {
      // モードボタンの見た目
      modeBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mode') === mode ? 'true' : 'false');
      });

      if (mode === 'mix') {
        flavorArea.hidden = true;
        flavorArea.innerHTML = '';
      } else {
        flavorArea.hidden = false;
        var max = mode === 'two' ? 2 : 1;
        setHint(''); // 重複案内は出さない（赤いステータスのみで案内）
        flavorArea.innerHTML = FLAVORS.map(function (f) {
          var on = selected.indexOf(f) !== -1;
          return '<button type="button" class="htfp__flavor-btn" data-flavor="' + f + '" aria-pressed="' + on + '">' +
            '<span class="htfp__check">' + (on ? '✓' : '') + '</span>' + f + 'ブレンド</button>';
        }).join('');
        flavorArea.querySelectorAll('[data-flavor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var f = btn.getAttribute('data-flavor');
            var i = selected.indexOf(f);
            if (i !== -1) {
              selected.splice(i, 1);
            } else {
              if (selected.length >= max) selected.shift(); // 上限超えたら古いものを外す
              selected.push(f);
            }
            render();
          });
        });
      }
      update();
    }

    function update() {
      if (mode === 'mix') {
        propInput.value = '3種ミックス（おまかせ）';
        if (shippingLabelInput) shippingLabelInput.value = 'コーヒー20個（3種）';
        setStatus('3種ミックス（おまかせ）でお届けします', true);
        setHint('');
        setValid(true);
      } else if (mode === 'two') {
        if (selected.length === 2) {
          propInput.value = selected.map(function (f) { return f + '×10個'; }).join('・');
          if (shippingLabelInput) {
            var codes = selected.map(function (f) { return FLAVOR_CODES[f]; });
            shippingLabelInput.value = 'コーヒー20個（' + codes.join('&') + '）';
          }
          setStatus(selected.join('・') + ' を10個ずつ', true);
          setValid(true);
        } else {
          propInput.value = '';
          if (shippingLabelInput) shippingLabelInput.value = '';
          setStatus('あと' + (2 - selected.length) + '種類選んでください', false);
          setValid(false);
        }
      } else { // one
        if (selected.length === 1) {
          propInput.value = selected[0] + '×20個';
          if (shippingLabelInput) shippingLabelInput.value = 'コーヒー20個（' + FLAVOR_CODES[selected[0]] + 'のみ）';
          setStatus(selected[0] + ' を20個', true);
          setValid(true);
        } else {
          propInput.value = '';
          if (shippingLabelInput) shippingLabelInput.value = '';
          setStatus('1種類選んでください', false);
          setValid(false);
        }
      }
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-mode');
        selected = [];
        render();
      });
    });

    render(); // 初期：mix（有効）
  }

  /* ── ステッパー式（100/200個：25個袋単位 / 25袋サブスク：5袋単位） ─────────────────── */
  function initStepperUI(root, bags, set, stepSize, propInput, shippingLabelInput, setValid, setStatus, setHint) {
    var area = root.querySelector('[data-htfp-steppers]');
    var counts = {};
    FLAVORS.forEach(function (f) { counts[f] = 0; });

    // 25袋サブスクは「袋」単位、100/200 は 25個入り袋単位で表記
    var isSub25 = set === 25;
    var unitLabel = isSub25 ? '袋' : '個';  // ステータスの単位 (25袋 or 100個)

    // 初期配分（合計 bags ぴったり・すぐ買える状態）
    // 4: [2,1,1] = 100個(50/25/25), 8: [3,3,2] = 200個(75/75/50), 5: [2,2,1] = 25袋(10/10/5)
    var defaults = bags === 4 ? [2, 1, 1] : bags === 8 ? [3, 3, 2] : bags === 5 ? [2, 2, 1] : null;
    if (defaults) {
      FLAVORS.forEach(function (f, i) { counts[f] = defaults[i]; });
    }

    area.innerHTML = FLAVORS.map(function (f) {
      return '<div class="htfp__stepper" data-flavor="' + f + '">' +
        '<span class="htfp__stepper-name">' + f + 'ブレンド</span>' +
        '<span class="htfp__stepper-ctrl">' +
          '<button type="button" class="htfp__step-btn" data-dec aria-label="' + f + 'を減らす">−</button>' +
          '<span class="htfp__count" data-count>0</span>' +
          '<button type="button" class="htfp__step-btn" data-inc aria-label="' + f + 'を増やす">＋</button>' +
        '</span>' +
      '</div>';
    }).join('');

    function total() {
      return FLAVORS.reduce(function (s, f) { return s + counts[f]; }, 0);
    }

    function render() {
      FLAVORS.forEach(function (f) {
        var row = area.querySelector('[data-flavor="' + f + '"]');
        // 25袋サブスクは「5袋刻み」に見えるよう表示値を stepSize 倍で出す (内部の counts は unit 数のまま)
        var displayCount = isSub25 ? counts[f] * stepSize : counts[f];
        row.querySelector('[data-count]').textContent = displayCount;
        var t = total();
        row.querySelector('[data-inc]').disabled = t >= bags;
        row.querySelector('[data-dec]').disabled = counts[f] <= 0;
      });
      update();
    }

    function update() {
      var t = total();
      if (t === bags) {
        var parts = FLAVORS.filter(function (f) { return counts[f] > 0; })
          .map(function (f) {
            if (isSub25) {
              return f + '×' + (counts[f] * stepSize) + '袋';
            }
            return f + '×' + counts[f] + '袋(' + (counts[f] * stepSize) + '個)';
          });
        propInput.value = parts.join('・');
        if (shippingLabelInput) {
          var codes = FLAVORS.filter(function (f) { return counts[f] > 0; })
            .map(function (f) { return FLAVOR_CODES[f] + counts[f]; });
          if (isSub25) {
            shippingLabelInput.value = 'コーヒー25袋(' + codes.join('/') + ')';
          } else {
            shippingLabelInput.value = 'コーヒー' + set + '個(' + codes.join('/') + ')';
          }
        }
        setStatus('合計' + set + unitLabel + 'ぴったり！', true);
        setHint(parts.join(' / '));
        setValid(true);
      } else {
        propInput.value = '';
        if (shippingLabelInput) shippingLabelInput.value = '';
        var diff = bags - t;
        var remainingUnits = Math.abs(diff) * (isSub25 ? stepSize : 1);
        var remainingLabel = isSub25 ? '袋' : '袋';  // どちらも「袋」表記で統一
        if (diff > 0) {
          setStatus('あと ' + remainingUnits + remainingLabel + ' 選んでください', false);
        } else {
          setStatus(remainingUnits + remainingLabel + ' 多いです', false);
        }
        setHint('');
        setValid(false);
      }
    }

    area.querySelectorAll('[data-flavor]').forEach(function (row) {
      var f = row.getAttribute('data-flavor');
      row.querySelector('[data-inc]').addEventListener('click', function () {
        if (total() < bags) { counts[f]++; render(); }
      });
      row.querySelector('[data-dec]').addEventListener('click', function () {
        if (counts[f] > 0) { counts[f]--; render(); }
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-htfp]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // クイック追加モーダル等で後から挿入される場合に備える
  document.addEventListener('shopify:section:load', initAll);
})();
